export default "__VITE_ASSET__DF_bEHJO__"